import { render } from "./historyComponent.vue?vue&type=template&id=12a4adfd"
import script from "./historyComponent.vue?vue&type=script&lang=js"
export * from "./historyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__